import hlisb_brand from "/content/dam/hlb/my/chatbot/images/hlisb-brand.png";

export default function HLISBLogo() {
    return (
        <img src={ hlisb_brand } alt="Hong Leong Islamic Bank"/>
    );
};
